import { fundsSections, managerSections } from './sections';

export const REPORT_TYPE_IDS = {
  AIF001: 'AIF001',
  AIF002: 'AIF002'
};

export const reportTypesV1 = [
  {
    id: REPORT_TYPE_IDS.AIF001,
    title: 'Manager',
    sections: managerSections
  },
  {
    id: REPORT_TYPE_IDS.AIF002,
    title: 'Funds',
    sections: fundsSections
  }
];
